import React from 'react';
import { Icon, Button, Modal } from 'antd';
import { SettingAPI } from '../../../../../requests'
import './style.less';

const clsPrefix = "cn-domain-info";
interface DomainInfoProps {
  privateDomain?: string,
  leftTime?: string | null,
  status?: number | null,
  siteId?: string,
}

const DomainInfo: React.FC<DomainInfoProps> = ({
  privateDomain,
  leftTime,
  status,
  siteId,
}) => {

  function handleUnBind() {
    Modal.confirm({
      title: `您确定要解除${privateDomain}与站点的绑定么？`,
      content: '解除绑定后，该域名无法访问您的站点',
      okText: '确定',
      cancelText: '取消',
      async onOk() {
        const result:any = await SettingAPI.unBindDomain({
          site_id:siteId
        })
        if (result && result.ret === 0) {
          window.location.reload()
        }
      },
      onCancel() {}
    })
  }

  return (
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__state-contain`}>
          <span className={`${clsPrefix}__private-domain`}>
            {`独立域名 ${privateDomain}`}
            <span className={`${clsPrefix}__state`}>
              {status === 0 && (
                <>
                  <Icon type="clock-circle" theme="filled" style={{color: 'yellow'}} className={`${clsPrefix}__Icon`}/>
                  绑定中...
                </>
                )
              }
              {status === 1 && (
                <>
                  <Icon type="close-circle" theme="filled" style={{color: 'red'}}className={`${clsPrefix}__Icon`}/>
                  绑定失败
                </>
                )
              }
              {status === 2 && (
                <>
                  <Icon type="check-circle" theme="filled" className={`${clsPrefix}__Icon`}/>
                  绑定成功
                </>
                )
              }
            </span>
          </span>
          <Button type="link" onClick={handleUnBind}>解除绑定</Button>
      </div>
      {
        status !== 2 && (
          <div className={`${clsPrefix}__message`}>
            {status === 0 && <p>绑定大约需要{leftTime && Math.abs(parseInt(leftTime))}分钟，请您稍后查看</p>}
            {
              status === 1 && 
              <p>
                经检测您的独立域名的cdn以被其他帐号绑定
                <a href="https://wiki.kuaizhan.com/pub/%E5%8A%9F%E8%83%BD%E8%AF%A6%E8%A7%A3/%E8%AE%BE%E7%BD%AE/%E7%BB%91%E5%AE%9A%E7%8B%AC%E7%AB%8B%E5%9F%9F%E5%90%8D">
                  如何解决
                </a>
              </p>
            }
          </div>
          )
        }
      <span className={`${clsPrefix}__tip`}>
        <span>提示</span>&nbsp;重新绑定域名请解除当前域名绑定
      </span>
    </div>
  )
}

export default DomainInfo;